module.exports = __webpack_public_path__ + "img/13n.baaf7062.png";